import { restGet } from "../../apiCommandsExecutor/rest";
import { AliasBinding } from "./models";
import { Menu } from "../menu/models";

export interface AliasBindingWithMenusRest {
    aliasBinding: AliasBinding;
    menusByOrgBranchIdByMenuId: { [organizationBranchId: number]: { [menuId: number]: Menu } };
}

/*
* Биндинг одного алиаса за загрузку страницы запрашивают три места (useAlias в MenuTypeWrapper
* и в MenuView, плюс generalMenuStore.getMenuByAlias), причём последовательно — дедупликации
* «на лету» тут мало, нужен именно кэш результата.
* */
const aliasBindingCache: { [alias: string]: Promise<AliasBindingWithMenusRest | null> } = {};

// Несуществующая ссылка — обычный ответ null, а не сбой: гость мог набрать её руками.
export const getAliasBinding = (alias: string) => {
    if (!aliasBindingCache[alias]) {
        aliasBindingCache[alias] = restGet<AliasBindingWithMenusRest>(`/alias-bindings/${alias}`)
            .then((res) => {
                // Пустой ответ не кэшируем: следующий заход должен сходить на бэк заново.
                if (!res) delete aliasBindingCache[alias];
                return res;
            })
            .catch((e) => {
                delete aliasBindingCache[alias];
                throw e;
            });
    }

    return aliasBindingCache[alias];
};
